import { CONTROL } from "@angular/cdk/keycodes";
import { Directive, HostBinding, Input } from "@angular/core";
import { AbstractControl } from "@angular/forms";

@Directive({
  selector: '[formFieldState]'
})
export class FormFieldStateDirective {
  @Input('formFieldState') control: AbstractControl

  @HostBinding('class.interval-required')
  get intervalRequiredClass(): boolean {
    if (!this.control) return false;
    const ctlr = this.control
    return !(ctlr.touched && ctlr.invalid) && (ctlr.errors !== undefined)
  }

  @HostBinding('class.interval-completed')
  get intervalCompletedClass(): boolean {
    if (!this.control) return false;
    const ctlr = this.control
    if (!this._hasValidator(ctlr)) return false
    return ctlr.value !== null && ctlr.value !== '' && ctlr.value !== undefined && !ctlr.errors
  }

  private _hasValidator(control: AbstractControl): boolean {
    return !!control.validator
  }
}